// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-link[data-v-0831452e]{display:inline-flex;align-items:center;color:#002560;font-size:20px;font-size:16px;font-weight:500;margin-bottom:5px}.menu-link span[data-v-0831452e]{margin-left:5px;border-bottom:2px solid #002560}.menu-caption[data-v-0831452e]{color:#777e85;font-size:12px;max-width:300px}\n", ""]);
// Exports
module.exports = exports;
